import type { MinifiedEntrySys } from '~/types/MinifiedSecondaryNavigation';
import { isSerializableRecord } from './isSerializableRecord';

/**
 * Strips Contentful sys down to what secondary-navigation consumers need:
 * entry guards, Vue keys, locale for `buildLinkInterface`, group URNs for visibility.
 */
export function compactPayloadEntrySys(
  sys: unknown
): MinifiedEntrySys | undefined {
  if (!isSerializableRecord(sys) || typeof sys.id !== 'string') {
    return undefined;
  }

  const contentTypeSys = isSerializableRecord(sys.contentType)
    ? sys.contentType.sys
    : undefined;

  const result: MinifiedEntrySys = {
    id: sys.id,
    type: sys.type === 'Link' ? 'Link' : 'Entry'
  };

  if (typeof sys.locale === 'string') {
    result.locale = sys.locale;
  }

  if (
    isSerializableRecord(contentTypeSys) &&
    typeof contentTypeSys.id === 'string'
  ) {
    result.contentType = {
      sys: {
        id: contentTypeSys.id,
        type: 'Link',
        linkType: 'ContentType'
      }
    };
  }

  if (typeof sys.urn === 'string') {
    result.urn = sys.urn;
  }

  if (typeof sys.linkType === 'string') {
    result.linkType = sys.linkType;
  }

  return result;
}
